module.exports = __webpack_public_path__ + "img/portrait-032.e53f17ed.jpg";